/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/style-prop-object */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Spinner,
  Table,
  Input,
  Button,
  ButtonIcon,
  DialogNew,
  Dropdown,
  Feedback,
} from '@optimizely/axiom';

import EditTeam from './EditTeam';
import { formatDate } from '../utils';
import { fetchTeams, deleteTeam } from '../../api/userApi';
import ConfirmationModal from './ConfirmationModal';

const TeamsList = (props) => {
  const { accountId } = props;
  const [data, setData] = useState(null);
  const [searchValue, setSearchValue] = useState(null);
  const [searchResults, setSearchResults] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [teamToDelete, setTeamToDelete] = useState(null);

  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

  const handleShowFeedback = (message) => {
    setFeedbackMessage(message);
    setIsFeedbackOpen(true);
  };

  const [error, setError] = useState(null);

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const teams = await fetchTeams(accountId);
      setData(teams);
    } catch (err) {
      setError('Unable to retrieve teams permissions.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteTeam = async () => {
    try {
      await deleteTeam(accountId, teamToDelete.id);
      setFeedbackMessage(`Team "${teamToDelete?.name}" successfully deleted`);
      setIsFeedbackOpen(true);

      setIsConfirmationModalOpen(false);
      setTeamToDelete(null);
      setSearchResults(null);
      setSearchValue('');
      fetchData();
    } catch (error) {
      setError('Unable to complete deletion.');
      setIsConfirmationModalOpen(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId]);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchValue(query);
    const results = data.filter(
      (item) =>
        item.name.toLowerCase().includes(query) ||
        (item.description && item.description.toLowerCase().includes(query)),
    );
    setSearchResults(results);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    fetchData(); // Fetch updated teams data
  };

  return (
    <>
      <Feedback
        type="good-news"
        open={isFeedbackOpen}
        onClose={() => setIsFeedbackOpen(false)}
      >
        {feedbackMessage}
      </Feedback>
      <div className="flex flex--1 flex--column">
        <div className="flex flex--none push-quad--sides push-double--ends">
          <div className="flex--1">
            <Input
              isFilter={true}
              placeholder="Filter by name or description"
              testSection="filter-permission-team"
              onChange={handleSearch}
              value={searchValue}
              className="width--300"
            />
          </div>
          <div className="flex flex--none push-left--single">
            <Button
              // isDisabled={!canAddTeam}
              style="highlight"
              onClick={() => {
                setSelectedTeam(null);
                setDialogOpen(true);
              }}
              testSection="add-team-button">
              Add Team…
            </Button>
          </div>
        </div>
        <div className="flex flex--1 flex--column soft-double--sides soft-double--bottom overflow-y--auto position--relative">
          <Table density={'loose'} tableLayoutAlgorithm="auto">
            <Table.THead>
              <Table.TR>
                <Table.TH>Name</Table.TH>
                <Table.TH>Created</Table.TH>
                <Table.TH textAlign="right">Members</Table.TH>
                <Table.TH textAlign="right"></Table.TH>
              </Table.TR>
            </Table.THead>
            <Table.TBody>
              {!isLoading &&
                (searchResults || data) &&
                (searchResults || data).map((team, index) => (
                  <Table.TR key={index}>
                    <Table.TD>
                      <div>
                        <a
                          onClick={() => {
                            setDialogOpen(true);
                            setSelectedTeam(team);
                          }}>
                          {team.name}
                        </a>
                      </div>
                      <div className="muted">{team.description}</div>
                    </Table.TD>
                    <Table.TD>{formatDate(team.created)}</Table.TD>
                    <Table.TD textAlign="right">{team.members_count}</Table.TD>
                    <Table.TD textAlign="right">
                      <div className="text--right">
                        <Dropdown
                          placement={'bottom-end'}
                          renderActivator={({ onClick, buttonRef, onBlur }) => (
                            <ButtonIcon
                              iconFill="default"
                              iconName="ellipsis-solid"
                              buttonRef={buttonRef}
                              onBlur={onBlur}
                              onClick={(e) => {
                                e.stopPropagation();
                                onClick(e);
                              }}
                              size="small"
                              style="plain"
                              testSection="team-more-options"
                              title="More options"
                            />
                          )}
                          shouldHideChildrenOnClick={true}
                          shouldHideChildrenOnTriggerBlur={true}
                          width={200}>
                          <Dropdown.Contents>
                            <Dropdown.ListItem>
                              <Dropdown.BlockLink
                                onClick={() => {
                                  setDialogOpen(true);
                                  setSelectedTeam(team);
                                }}>
                                <Dropdown.BlockLinkText
                                  testSection="edit-team"
                                  text="Edit Team"
                                />
                              </Dropdown.BlockLink>
                            </Dropdown.ListItem>
                            <Dropdown.ListItem>
                              <Dropdown.BlockLink
                                onClick={() => {
                                  setTeamToDelete(team);
                                  setIsConfirmationModalOpen(true);
                                }}>
                                <Dropdown.BlockLinkText
                                  isDestructive
                                  testSection="delete-team"
                                  text="Delete"
                                />
                              </Dropdown.BlockLink>
                            </Dropdown.ListItem>
                          </Dropdown.Contents>
                        </Dropdown>
                      </div>
                    </Table.TD>
                  </Table.TR>
                ))}
              {isLoading && <Spinner hasOverlay={true} />}
            </Table.TBody>
          </Table>
        </div>
        {dialogOpen && (
          <EditTeam
            setDialogOpen={setDialogOpen}
            accountId={accountId}
            selectedTeam={selectedTeam}
            setSelectedTeam={setSelectedTeam}
            onClose={handleDialogClose} // Pass the callback to EditTeam
            showFeedback={handleShowFeedback}
          />
        )}
      </div>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onClose={() => {
          setIsConfirmationModalOpen(false);
          setTeamToDelete(null);
        }}
        onConfirm={handleDeleteTeam}
        teamName={teamToDelete?.name || ''}
      />
      {error && (
        <DialogNew
          title={error.includes('retrieve') 
            ? "Loading issue" 
            : "Deletion issue"}
          hasCloseButton={true}
          testSection="error-modal-teams"
          onClose={() => {
            setError(null);
          }}
          footerButtonList={[
            <Button
              key="close"
              className="oui-button oui-button--plain oui-button--default"
              onClick={() => {
                setError(null);
              }}>
              Close
            </Button>,
          ]}>
          <p>{error}</p>
        </DialogNew>
      )}
    </>
  );
};

export default TeamsList;
